import * as actionTypes from '../actions/actionTypes';

export default function generateDoc(state = {}, action) {
  switch(action.type){
    case actionTypes.SET_GENERATE_DOC:{
      return action.generatedata.reduce((accumulator, _case, index) => {
        accumulator[_case.id] = {..._case };
        return accumulator;
      }, {});
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/CaseBody/reducers/generateDocReducer.js